module.exports = __webpack_public_path__ + "img/first-access.a0bc4606.svg";